import { Flux, Playlist } from "@/savaradio/common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
  upload: false
}

export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value?: Flux[], mounted: string[], isLoading: IsLoading } = { mounted: [], isLoading: initialLoading }
const fluxSlice = createSlice({
  initialState,
  name: "flux_slice",
  reducers: {
    append: (state, action: PayloadAction<Flux>) => {
      if (!state.value) state.value = [action.payload]
      if (state.value && !state.value.some(f => f._id === action.payload._id)) state.value = state.value.concat(action.payload)
    },
    pop: (state, action: PayloadAction<Flux>) => {
      if (state.value) state.value = state.value.filter(f => f._id !== action.payload._id)
    },
    update: (state, action: PayloadAction<Flux>) => {
      if (state.value) state.value = state.value.map(f => f._id === action.payload._id ? action.payload : f)
    },
    reset: (state, action: PayloadAction<Flux[] | undefined>) => {
      state.value = action.payload
    },
    setMounted: (state, action: PayloadAction<string[]>) => {
      state.mounted = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    },
  }
})

export const { append, pop, update, reset, setMounted, setLoading } = fluxSlice.actions
export const flux_slice = fluxSlice.reducer